// 评测
const evaluatingRouter = [
  {
    path: '/evaluation',
    name: 'Evaluation',
    component: () => import('@/views/evaluation/index.vue')
  },
  {
    path: '/evaluationDetail',
    name: 'EvaluationDetail',
    component: () => import('@/views/evaluation/evaluationDetail.vue')
  },
  {
    path: '/evaluation_more',
    name: 'Evaluation_more',
    component: () => import('@/views/evaluation/evaluation_more.vue')
  },
  {
    path: '/exerciseMode',
    name: 'ExerciseMode',
    component: () => import('@/views/evaluating/exerciseMode.vue'),
    meta: {
      title: '',
      hideHead: true,
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/eAnsSheet',
    name: 'eAnsSheet',
    component: () => import('@/views/evaluating/eAnsSheet.vue'),
    meta: {
      hideHead: true,
      title: ''
    }
  },
  {
    path: '/exerciseResult',
    name: 'ExerciseResult',
    component: () => import('@/views/evaluating/exerciseResult.vue'),
    meta: {
      hideHead: true,
      title: ''
    }
  },
  {
    path: '/analysis',
    name: 'Analysis',
    component: () => import('@/views/evaluating/analysis.vue'),
    meta: {
      hideHead: true,
      title: ''
    }
  },
  {
    path: '/znst',
    name: 'znst',
    component: () => import('@/views/evaluating/znst.vue'),
    meta: {
      hideHead: true,
      title: ''
    }
  },
  {
    path: '/exerciseReport',
    name: 'ExerciseReport',
    component: () => import('@/views/evaluating/exerciseReport.vue'),
    meta: {
      hideHead: true,
      title: ''
    }
  },
  {
    path: '/errorExercise',
    name: 'errorExercise',
    component: () => import('@/views/evaluating/errorExercise.vue'),
    meta: {
      hideHead: true,
      title: ''
    }
  }
]
export default evaluatingRouter
